import { useAuth } from '../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Mail, ArrowRight } from 'lucide-react';

export const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!user || user.email_verified || user.is_admin) return null;

  return (
    <div 
      className="bg-amber-500/15 dark:bg-[#ffff00]/10 border-b border-amber-500/40 dark:border-[#ffff00]/30 px-4 py-2.5 flex items-center justify-between cursor-pointer hover:bg-amber-500/25 dark:hover:bg-[#ffff00]/15 transition-colors md:ml-48"
      onClick={() => navigate('/verify-email', { state: { from: location.pathname } })}
      data-testid="email-verification-banner"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') navigate('/verify-email', { state: { from: location.pathname } }); }}
    >
      <div className="flex items-center gap-3 min-w-0">
        <Mail size={16} className="text-amber-600 dark:text-[#ffff00] shrink-0" />
        <span className="text-amber-700 dark:text-[#ffff00] font-mono text-xs sm:text-sm truncate">
          Please verify your email to unlock uploading, purchasing, and messaging
        </span>
      </div>
      <ArrowRight size={16} className="text-amber-600 dark:text-[#ffff00] shrink-0 ml-2" />
    </div>
  );
};
